import apiClient from "./apiClient";
import {
  flattenPermissionsFromAuthMe,
  normalizeAuthzAppType,
  resolveProfileForApp,
} from "./authzPermissions";

/**
 * AuthZ via POS (industrial path):
 *   FE → POS :8080/POS/{company}/{homsInstance}/UserManagement/auth/me
 *     → UserManagement :7018 → UMS :8097
 *
 * POS resolves the UMS instance from BOP; FE must NOT call 7018 directly.
 */
export function resolveKeycloakUserKey(authUser) {
  if (!authUser) return "";
  return (
    authUser.preferred_username ||
    authUser.username ||
    authUser.userName ||
    authUser.sub ||
    authUser.keycloakUserId ||
    ""
  );
}

/**
 * GET /UserManagement/auth/me through POS basePath + Bearer token.
 * Scopes permissions + profile to the current app when appType is provided.
 */
export async function fetchAuthMeContext({ companyName, keycloakUserId, appType }) {
  const company = String(companyName || "").trim();
  const userKey = String(keycloakUserId || "").trim();
  if (!company || !userKey) {
    throw new Error("companyName and keycloakUserId are required for auth/me");
  }

  const endpoint =
    `/UserManagement/auth/me?keycloakUserId=${encodeURIComponent(userKey)}` +
    `&companyKey=${encodeURIComponent(company)}`;

  const payload = await apiClient.get(endpoint, {
    context: "Loading authorization",
    silent: true,
    hideLoader: true,
  });

  const app = normalizeAuthzAppType(appType);
  const scoped = {
    ...payload,
    profiles: Array.isArray(payload?.profiles) ? payload.profiles : [],
    permissions: flattenPermissionsFromAuthMe(payload, app),
  };
  const appProfile = resolveProfileForApp(scoped, app);
  // Always set profile to this app only (null when unassigned — never keep HPOS while on HOMS).
  scoped.profile = appProfile || null;
  return scoped;
}
